module.exports = __webpack_public_path__ + "img/logo-gea.9d67014f.png";